var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.384 6C67.444 6 74 12.556 74 20.616V59.386C74 67.444 67.444 74 59.384 74H20.616C12.556 74 6 67.444 6 59.384V20.616C6 12.556 12.556 6 20.616 6H59.384ZM59.384 4H20.616C11.438 4 4 11.438 4 20.616V59.386C4 68.562 11.438 76 20.616 76H59.386C68.562 76 76 68.562 76 59.384V20.616C76 11.438 68.562 4 59.384 4Z",
    fill: "#1C64F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75C20.702 75 5 59.298 5 40C5 20.702 20.702 5 40 5C59.298 5 75 20.702 75 40C75 59.298 59.298 75 40 75ZM40 21C29.524 21 21 29.524 21 40C21 50.476 29.524 59 40 59C50.476 59 59 50.476 59 40C59 29.524 50.476 21 40 21Z",
    fill: "#DFF0FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 6C58.748 6 74 21.252 74 40C74 58.748 58.748 74 40 74C21.252 74 6 58.748 6 40C6 21.252 21.252 6 40 6ZM40 60C51.028 60 60 51.028 60 40C60 28.972 51.028 20 40 20C28.972 20 20 28.972 20 40C20 51.028 28.972 60 40 60ZM40 4C20.118 4 4 20.118 4 40C4 59.882 20.118 76 40 76C59.882 76 76 59.882 76 40C76 20.118 59.882 4 40 4ZM40 58C30.058 58 22 49.942 22 40C22 30.058 30.058 22 40 22C49.942 22 58 30.058 58 40C58 49.942 49.942 58 40 58Z",
    fill: "#1C64F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 3H45V23H35V3Z",
    fill: "#B6DCFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 4V22H36V4H44ZM46 2H34V24H46V2Z",
    fill: "#1C64F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 57H45V77H35V57Z",
    fill: "#B6DCFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58V76H36V58H44ZM46 56H34V78H46V56Z",
    fill: "#1C64F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57 35H77V45H57V35Z",
    fill: "#B6DCFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76 36V44H58V36H76ZM78 34H56V46H78V34Z",
    fill: "#1C64F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3 35H23V45H3V35Z",
    fill: "#B6DCFE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36V44H4V36H22ZM24 34H2V46H24V34Z",
    fill: "#1C64F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.34a6acc22a90a1c0941c07ff0ebbdc2a.svg";
export { ForwardRef as ReactComponent };